
// Meta Pixel Tracking Helper
function trackPixel(event, params = {}) {
  try {
    if (typeof window.fbq === 'function') {
      const urlParams = new URLSearchParams(window.location.search);
      const testCode = urlParams.get('test_event_code') || 'TEST95024';
      if (testCode) {
        params.test_event_code = testCode;
        window.fbq('track', event, params, { test_event_code: testCode });
      } else {
        window.fbq('track', event, params);
      }
      console.log('[Meta Pixel Tracked]', event, params);
    }
  } catch (err) {
    console.warn('[Meta Pixel Warning]', err);
  }
}
/**
 * VERRINA SKIN CARE - MASTERPIECE STORE CONTROLLER
 * High-Converting 1-Click COD Checkout, Multi-Modal Architecture & Dynamic Bundling
 */

const state = {
  selectedBundle: {
    id: 'bundle-1',
    bottles: 1,
    pricePKR: 1799,
    originalPKR: 2999,
    shippingPKR: 200,
    title: 'Individual Radiance Bottle (1x 30ml)',
    savings: '40% OFF • Save Rs. 1,200',
    pricePerBottle: 1799,
    isFreeShipping: false
  },
  quantity: 1,
  cart: [],
  cartBottleCount: 0,
  paymentMethod: 'cod',
  advanceDiscountPKR: 100,
  checkoutSource: 'bundle'
};

const BUNDLE_DATA = {
  'bundle-1': {
    id: 'bundle-1',
    variantId: 67736234295598,
    bottles: 1,
    pricePKR: 1799,
    originalPKR: 2999,
    shippingPKR: 200,
    title: 'Individual Radiance Bottle (1x 30ml)',
    savings: '40% OFF • Save Rs. 1,200',
    pricePerBottle: 1799,
    isFreeShipping: false
  },
  'bundle-2': {
    id: 'bundle-2',
    variantId: 67736234328366,
    bottles: 2,
    pricePKR: 3399,
    originalPKR: 5998,
    shippingPKR: 0,
    title: 'Duo Radiance Protocol (2x 30ml)',
    savings: 'Save Rs. 2,599 • FREE TCS Delivery',
    pricePerBottle: 1700,
    isFreeShipping: true
  }
};

function formatPKR(val) {
  return `Rs. ${Math.round(val).toLocaleString()}`;
}

function getPricingForBottles(count) {
  if (count <= 1) {
    return {
      bundleId: 'bundle-1',
      title: 'Individual Radiance Bottle (1x 30ml)',
      bottles: 1,
      pricePKR: 1799,
      shippingPKR: 200,
      isFreeShipping: false,
      badge: 'Trial Routine (30 Days)',
      savingsText: '+ Rs. 200 TCS Delivery'
    };
  } else {
    const extra = Math.max(0, count - 2);
    const price = 3399 + (extra * 1700);
    return {
      bundleId: 'bundle-2',
      title: count === 2 ? '2 Bottles • Duo Treatment Pack (2x 30ml)' : `${count} Bottles Treatment Pack`,
      bottles: count,
      pricePKR: price,
      shippingPKR: 0,
      isFreeShipping: true,
      badge: 'Duo Pack • FREE TCS Delivery',
      savingsText: 'Save Rs. 2,599 • Free Delivery'
    };
  }
}

/* ==========================================================================
   Zero-Scroll & Default State Enforcement Engine
   ========================================================================== */
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

window.addEventListener('beforeunload', () => {
  window.scrollTo(0, 0);
});

window.addEventListener('load', () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  if (window.location.hash) {
    history.replaceState(null, null, window.location.pathname + window.location.search);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  window.scrollTo(0, 0);
  initAnnouncementRotator();
  initMobileMenu();
  loadProductsJSON();
  initGallery();
  initBundleSelector();
  initQuantityControls();
  initOneClickCheckout();
  initTrackOrderModal();
  initAboutUsModal();
  initCartDrawer();
  initBeforeAfterSlider();
  initFAQAccordion();
  initStickyBar();
  // initSocialProof(); // disabled for authenticity
  initWhatsAppFloating();
  // initTikTokModal(); // disabled
  selectBundle('bundle-1'); // Strict clean default to Bundle 1
  updateCTA();
  if (typeof closeAllModals === 'function') closeAllModals();
});

async function loadProductsJSON() {
  try {
    const res = await fetch('products.json');
    if (res.ok) {
      const data = await res.json();
      if (data && data.product && data.product.bundles) {
        data.product.bundles.forEach(b => {
          if (BUNDLE_DATA[b.id]) {
            BUNDLE_DATA[b.id].pricePKR = b.pricePKR;
            BUNDLE_DATA[b.id].shippingPKR = b.shippingPKR;
            BUNDLE_DATA[b.id].isFreeShipping = b.isFreeShipping;
            BUNDLE_DATA[b.id].title = b.title;
          }
        });
      }
    }
  } catch (err) {
    // Default fallback state preserved
  }
}

/* ==========================================================================
   1. Interactive Image Gallery
   ========================================================================== */
function initGallery() {
  const mainImage = document.getElementById('gallery-main');
  const thumbnails = document.querySelectorAll('.thumbnail-box');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-src');
      if (mainImage && src) {
        mainImage.style.opacity = '0.3';
        setTimeout(() => {
          mainImage.src = src;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.style.opacity = '1';
        }, 120);

        thumbnails.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  if (mainImage) {
    const parent = mainImage.parentElement;
    parent.addEventListener('mousemove', (e) => {
      const rect = parent.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImage.style.transformOrigin = `${x}% ${y}%`;
    });

    parent.addEventListener('mouseenter', () => {
      mainImage.style.transform = 'scale(1.25)';
    });

    parent.addEventListener('mouseleave', () => {
      mainImage.style.transform = 'scale(1)';
    });
  }
}

/* ==========================================================================
   2. Bundle Selection & Smart Sync
   ========================================================================== */
function selectBundle(bundleId) {
  trackPixel("AddToCart", { content_name: BUNDLE_DATA[bundleId]?.title || bundleId, value: BUNDLE_DATA[bundleId]?.pricePKR || 1799, currency: "PKR" });
  if (!BUNDLE_DATA[bundleId]) return;
  state.selectedBundle = BUNDLE_DATA[bundleId];

  // Set quantity counter: 1 for 1-bottle, 2 for 2-bottles, 3 for 3+1 FREE
  if (bundleId === 'bundle-1') state.quantity = 1;
  else if (bundleId === 'bundle-2') state.quantity = 2;
  
  const val = document.getElementById('qty-val');
  if (val) val.textContent = state.quantity;

  // Sync main bundle cards
  document.querySelectorAll('.bundle-card').forEach(c => {
    if (c.getAttribute('data-bundle-id') === bundleId) {
      c.classList.add('selected');
      const radio = c.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    } else {
      c.classList.remove('selected');
    }
  });

  // Sync sticky quick pills
  document.querySelectorAll('.sticky-pill-btn').forEach(btn => {
    if (btn.getAttribute('data-bundle-id') === bundleId) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  updateCTA();
  updateStickyBar();
}

function initBundleSelector() {
  const cards = document.querySelectorAll('.bundle-card');
  cards.forEach(card => {
    card.addEventListener('click', () => {
      const bId = card.getAttribute('data-bundle-id');
      selectBundle(bId);
    });
  });
}

function updateCTA() {
  // Always display the exact package price: 1,799 / 3,399
  const total = state.selectedBundle.pricePKR;
  document.querySelectorAll('.cta-price-display').forEach(el => {
    el.textContent = formatPKR(total);
  });
}

/* ==========================================================================
   3. Quantity Controls (Smart Package Tiers: 1 [Rs. 1,799] -> 2 [Rs. 3,399])
   ========================================================================== */
function initQuantityControls() {
  const minus = document.getElementById('qty-minus');
  const plus = document.getElementById('qty-plus');

  if (minus && plus) {
    minus.addEventListener('click', () => {
      if (state.quantity >= 2) {
        selectBundle('bundle-1'); // Down to 1 Bottle (Rs. 1,799)
      }
    });

    plus.addEventListener('click', () => {
      if (state.quantity === 1) {
        selectBundle('bundle-2'); // Up to 2 Bottles (Rs. 3,399 Free Delivery)
      }
    });
  }
}

/* ==========================================================================
   4. 1-Click Cash on Delivery & Advance Payment Checkout Modal
   ========================================================================== */
function closeCartDrawer() {
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if (overlay) overlay.classList.remove('open');
  if (drawer) drawer.classList.remove('open');
  document.body.style.overflow = '';
}

function openCartDrawer() {
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if (overlay) overlay.classList.add('open');
  if (drawer) drawer.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function showCopyToast(msg) {
  const toast = document.getElementById('copy-toast');
  if (toast) {
    toast.textContent = msg || 'Copied to Clipboard!';
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2200);
  }
}

function getCheckoutCalculation() {
  if (state.checkoutSource === 'cart' && state.cartBottleCount > 0) {
    const pricing = getPricingForBottles(state.cartBottleCount);
    const shipping = pricing.shippingPKR;
    const discount = state.paymentMethod === 'advance' ? state.advanceDiscountPKR : 0;
    const total = Math.max(0, pricing.pricePKR + shipping - discount);
    return {
      title: pricing.title,
      subtotal: pricing.pricePKR,
      shipping: shipping,
      isFreeShipping: pricing.isFreeShipping,
      discount: discount,
      total: total,
      isCart: true
    };
  } else {
    const bottles = state.selectedBundle.id === 'bundle-2' ? 2 : 1;
    const pricing = getPricingForBottles(bottles);
    const shipping = pricing.shippingPKR;
    const discount = state.paymentMethod === 'advance' ? state.advanceDiscountPKR : 0;
    const total = Math.max(0, pricing.pricePKR + shipping - discount);
    return {
      title: pricing.title,
      subtotal: pricing.pricePKR,
      shipping: shipping,
      isFreeShipping: pricing.isFreeShipping,
      discount: discount,
      total: total,
      isCart: false
    };
  }
}

function setPaymentMethod(method) {
  state.paymentMethod = method;
  const codLabel = document.getElementById('pm-cod-label');
  const advLabel = document.getElementById('pm-advance-label');
  const advDetails = document.getElementById('advance-payment-details');
  const advDiscountRow = document.getElementById('oc-row-advance-discount');
  const submitBtn = document.getElementById('oc-submit-btn');
  const footerNote = document.getElementById('oc-footer-note');

  if (method === 'advance') {
    if (codLabel) codLabel.classList.remove('active-cod');
    if (advLabel) advLabel.classList.add('active-advance');
    if (advDetails) advDetails.classList.remove('hidden');
    if (advDiscountRow) advDiscountRow.classList.remove('hidden');
    if (submitBtn) {
      submitBtn.innerHTML = 'CONFIRM ORDER &amp; PAY VIA EASYPAISA (SAVE RS. 100) ➔';
    }
    if (footerNote) {
      footerNote.innerHTML = 'EasyPaisa advance pay: Flat Rs. 100 discount applied. Transfer to: <strong>03170619644 (Title: Hassan Raza)</strong>.';
    }
  } else {
    if (advLabel) advLabel.classList.remove('active-advance');
    if (codLabel) codLabel.classList.add('active-cod');
    if (advDetails) advDetails.classList.add('hidden');
    if (advDiscountRow) advDiscountRow.classList.add('hidden');
    if (submitBtn) {
      submitBtn.innerHTML = 'CONFIRM ORDER — PAY CASH ON DELIVERY ➔';
    }
    if (footerNote) {
      footerNote.innerHTML = 'No credit card needed. Pay cash when your parcel is delivered via TCS Express.';
    }
  }
  updateOneClickSummary();
}


// ==========================================================================
// REAL SHOPIFY CHECKOUT REDIRECT ENGINE (DIRECT LIVE ORDER INTEGRATION)
// ==========================================================================
function redirectToShopifyCheckout(bundleId) {
  const selected = bundleId || state.selectedBundle?.id || 'bundle-1';
  const variantId = selected === 'bundle-2' ? '67736234328366' : '67736234295598';
  const bundle = BUNDLE_DATA[selected] || BUNDLE_DATA['bundle-1'];

  trackPixel('InitiateCheckout', {
    content_name: bundle.title,
    value: bundle.pricePKR,
    currency: 'PKR'
  });

  // Instant UI feedback without freezing the main thread
  document.querySelectorAll('.oneclick-trigger, #oc-submit-btn').forEach(btn => {
    btn.disabled = true;
    btn.innerHTML = '<span>REDIRECTING TO CHECKOUT... 🚀</span>';
  });

  // ZERO-DELAY INSTANT SHOPIFY DIRECT PERMALINK
  // Bypasses /cart/clear.js and /cart/add.js wait times completely!
  window.location.href = '/cart/' + variantId + ':1';
}

function openOneClickModal(source = 'bundle') {
  // Directly forward to Shopify native checkout to guarantee 100% order capture
  redirectToShopifyCheckout(state.selectedBundle?.id);
}

function initOneClickCheckout() {
  const modal = document.getElementById('oneclick-modal');
  const triggers = document.querySelectorAll('.oneclick-trigger');
  const closeBtn = document.getElementById('close-oneclick-modal');
  const form = document.getElementById('oneclick-form');
  const successState = document.getElementById('oneclick-success');

  // Copy Button for EasyPaisa Number
  const copyNumberBtn = document.getElementById('copy-number-btn');
  if (copyNumberBtn) {
    copyNumberBtn.addEventListener('click', () => {
      navigator.clipboard.writeText('03170619644');
      showCopyToast('EasyPaisa Number "03170619644" Copied!');
    });
  }

  // Payment Method Selection Radios & Details
  const paymentRadios = document.querySelectorAll('input[name="payment_method"]');

  paymentRadios.forEach(radio => {
    radio.addEventListener('change', (e) => {
      setPaymentMethod(e.target.value);
    });
  });

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  triggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    redirectToShopifyCheckout(state.selectedBundle?.id);
  }));

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
  }

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      
      const name = document.getElementById('oc-name').value;
      const phone = document.getElementById('oc-phone').value;
      const city = document.getElementById('oc-city').value;
      const trxIdInput = document.getElementById('oc-trx-id');
      const trxId = trxIdInput ? trxIdInput.value.trim() : '';
      
      const orderNum = 'VR-' + Math.floor(100000 + Math.random() * 900000);
      document.getElementById('oc-conf-ordernum').textContent = orderNum;
      document.getElementById('oc-conf-name').textContent = name;
      document.getElementById('oc-conf-city').textContent = city;
      
      const calc = getCheckoutCalculation();
      trackPixel("Purchase", { content_name: calc.title, value: calc.total, currency: "PKR" });
      document.getElementById('oc-conf-total').textContent = formatPKR(calc.total);

      const confMethod = document.getElementById('oc-conf-payment-method');
      const confAdvBox = document.getElementById('oc-conf-advance-box');
      const confAdvAmount = document.getElementById('oc-conf-adv-amount');
      const waReceiptLink = document.getElementById('oc-whatsapp-receipt-link');

      if (state.paymentMethod === 'advance') {
        if (confMethod) confMethod.innerHTML = '<span class="text-[#107C41] font-bold">EasyPaisa (Rs. 100 Discount Applied)</span>';
        if (confAdvBox) confAdvBox.classList.remove('hidden');
        if (confAdvAmount) confAdvAmount.textContent = formatPKR(calc.total);

        const waText = encodeURIComponent(
          `Assalam o Alaikum! Maine Verrina Skin Care Order #${orderNum} ke liye EasyPaisa se advance payment bhej di hai.\n\n` +
          `• Item(s): ${calc.title}\n` +
          `• Total Amount: ${formatPKR(calc.total)} (Flat Rs. 100 Discount Applied)\n` +
          `• Sent to EasyPaisa: 03170619644 (Title: Hassan Raza)\n` +
          `• Name: ${name}\n` +
          `• Phone: ${phone}\n` +
          `• City: ${city}\n` +
          (trxId ? `• Trx ID / Sender: ${trxId}\n` : '') +
          `\nPayment screenshot attached. Baraye meharbani dispatch confirm karein.`
        );
        if (waReceiptLink) {
          waReceiptLink.href = `https://wa.me/923170619644?text=${waText}`;
        }
      } else {
        if (confMethod) confMethod.textContent = 'Cash on Delivery (COD via TCS)';
        if (confAdvBox) confAdvBox.classList.add('hidden');
      }

      // If checkout was from cart, empty cart now
      if (calc.isCart) {
        state.cart = [];
        renderCart();
      }

      // Forward order to Shopify Checkout so it creates a real order in Shopify Admin
      const submitBtn = document.getElementById('oc-submit-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'CREATING SHOPIFY ORDER... ⏳';
      }

      const activeVariantId = state.selectedBundle?.variantId || (state.selectedBundle?.id === 'bundle-2' ? 67736234328366 : 67736234295598);
      
      // Clear cart, add product, and redirect to checkout with prefilled customer details
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: activeVariantId, quantity: 1 })
        }))
        .then(() => {
          const address = document.getElementById('oc-address')?.value.trim() || '';
          const cleanPhone = phone.replace(/[^0-9]/g, '');
          const contactEmail = `${cleanPhone || 'order'}@orders.verrinaskincare.com`;
          
          // Smart Name Splitting:
          // e.g. 'Junaid Ahmad' -> first: 'Junaid', last: 'Ahmad'
          // e.g. 'Junaid' -> last: 'Junaid' (Shopify requires last_name!)
          const parts = name.trim().split(/\s+/);
          const firstName = parts.length > 1 ? parts[0] : '';
          const lastName = parts.length > 1 ? parts.slice(1).join(' ') : (parts[0] || 'Customer');

          const params = new URLSearchParams();
          params.append('checkout[email]', contactEmail);
          if (firstName) params.append('checkout[shipping_address][first_name]', firstName);
          params.append('checkout[shipping_address][last_name]', lastName);
          if (phone) params.append('checkout[shipping_address][phone]', phone);
          if (address) params.append('checkout[shipping_address][address1]', address);
          if (city) params.append('checkout[shipping_address][city]', city);
          params.append('checkout[shipping_address][country]', 'Pakistan');
          
          window.location.href = '/checkout?' + params.toString();
        })
        .catch(err => {
          console.error('Cart add error:', err);
          window.location.href = `/cart/${activeVariantId}:1`;
        });
    });
  }
}

function updateOneClickSummary() {
  const itemEl = document.getElementById('oc-summary-item');
  const priceEl = document.getElementById('oc-summary-price');
  const shipEl = document.getElementById('oc-summary-shipping');
  const totalEl = document.getElementById('oc-summary-total');
  const discountRow = document.getElementById('oc-row-advance-discount');

  if (!itemEl) return;

  const calc = getCheckoutCalculation();

  itemEl.textContent = calc.title;
  priceEl.textContent = formatPKR(calc.subtotal);
  
  if (calc.isFreeShipping) {
    shipEl.innerHTML = '<span class="text-green-700 font-bold">FREE (TCS Express)</span>';
  } else {
    shipEl.textContent = 'Rs. 200';
  }

  if (discountRow) {
    if (state.paymentMethod === 'advance') {
      discountRow.classList.remove('hidden');
    } else {
      discountRow.classList.add('hidden');
    }
  }

  totalEl.textContent = formatPKR(calc.total);
}

/* ==========================================================================
   5. Track Your Order Modal
   ========================================================================== */
function initTrackOrderModal() {
  const modal = document.getElementById('track-modal');
  const triggers = document.querySelectorAll('.track-order-trigger');
  const closeBtn = document.getElementById('close-track-modal');
  const lookupForm = document.getElementById('track-lookup-form');
  const resultBox = document.getElementById('track-result-box');

  function openTrack() {
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeTrack() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  triggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openTrack();
  }));

  if (closeBtn) closeBtn.addEventListener('click', closeTrack);
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeTrack();
    });
  }

  if (lookupForm) {
    lookupForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const trackingInput = document.getElementById('tracking-id-input').value;
      if (resultBox) {
        resultBox.classList.remove('hidden');
        document.getElementById('track-display-id').textContent = trackingInput;
      }
    });
  }
}

/* ==========================================================================
   6. About Us Modal
   ========================================================================== */
function initAboutUsModal() {
  const modal = document.getElementById('about-modal');
  const triggers = document.querySelectorAll('.about-us-trigger');
  const closeBtn = document.getElementById('close-about-modal');

  function openAbout() {
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeAbout() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  triggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openAbout();
  }));

  if (closeBtn) closeBtn.addEventListener('click', closeAbout);
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeAbout();
    });
  }
}

/* ==========================================================================
   7. Slide-Out Cart Drawer
   ========================================================================== */
/* ==========================================================================
   7. Slide-Out Cart Drawer (Smart Bundle Tiers: 1 [Rs. 1,799] -> 2 [Rs. 3,399])
   ========================================================================== */
function initCartDrawer() {
  const openTriggers = document.querySelectorAll('.cart-open-trigger');
  const closeBtn = document.getElementById('close-cart');
  const overlay = document.getElementById('cart-overlay');
  const addToBagBtn = document.getElementById('add-to-bag-btn');
  const proceedBtn = document.getElementById('cart-proceed-checkout-btn');

  openTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));

  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  if (proceedBtn) {
    proceedBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (state.cartBottleCount <= 0) {
        alert('Aap ka Shopping Bag khali hai. Baraye meharbani pehle package select karein.');
        return;
      }
      closeCartDrawer();
      openOneClickModal('cart');
    });
  }

  if (addToBagBtn) {
    addToBagBtn.addEventListener('click', () => {
      let bottlesToAdd = 1;
      if (state.selectedBundle.id === 'bundle-2') bottlesToAdd = 2;
      
      state.cartBottleCount = bottlesToAdd;
      renderCart();
      openCartDrawer();
    });
  }
}

function renderCart() {
  const container = document.getElementById('cart-items-container');
  const emptyState = document.getElementById('cart-empty-state');
  const badge = document.getElementById('cart-badge');
  const subtotalEl = document.getElementById('cart-subtotal');
  const freeShipText = document.getElementById('cart-freeship-text');
  const freeShipBar = document.getElementById('cart-freeship-bar');

  if (!container) return;

  if (badge) {
    badge.textContent = state.cartBottleCount > 0 ? state.cartBottleCount : 0;
    badge.style.display = state.cartBottleCount > 0 ? 'flex' : 'none';
  }

  if (state.cartBottleCount <= 0) {
    if (emptyState) emptyState.style.display = 'block';
    container.innerHTML = '';
    if (subtotalEl) subtotalEl.textContent = formatPKR(0);
    if (freeShipText) freeShipText.innerHTML = '2 ya ziyada bottles add karein aur payein <strong>FREE TCS Express Delivery</strong>';
    if (freeShipBar) freeShipBar.style.width = '0%';
    return;
  }

  if (emptyState) emptyState.style.display = 'none';

  const pricing = getPricingForBottles(state.cartBottleCount);

  // Dynamic Thumbnail Resolution (Works seamlessly on Shopify CDN and Localhost)
  let thumbUrl = (window.ShopifyThemeAssets && window.ShopifyThemeAssets['2.webp']) || '2.webp';
  const mainImg = document.getElementById('gallery-main');
  if (mainImg && mainImg.src && !mainImg.src.includes('undefined')) {
    thumbUrl = mainImg.src;
  } else if (window.ShopifyThemeAssets && window.ShopifyThemeAssets['2.webp']) {
    thumbUrl = window.ShopifyThemeAssets['2.webp'];
  } else if (window.ShopifyThemeAssets && window.ShopifyThemeAssets['2.jpg']) {
    thumbUrl = window.ShopifyThemeAssets['2.jpg'];
  }

  let html = `
    <div class="p-4 rounded-xl bg-[#FAF7F2] border border-[#E8DDD2] space-y-3">
      <div class="flex gap-3.5">
        <img src="${thumbUrl}" alt="${pricing.title}" class="w-16 h-16 object-cover rounded-lg border border-[#E8DDD2] flex-shrink-0" onerror="this.onerror=null;this.src=(window.ShopifyThemeAssets && window.ShopifyThemeAssets['2.jpg']) || '2.jpg'">
        <div class="flex-1 min-w-0">
          <div class="flex justify-between items-start gap-2">
            <h4 class="text-xs font-bold text-[#16120E] uppercase leading-tight truncate">${pricing.title}</h4>
            <button class="text-gray-400 hover:text-black text-xs font-bold p-0.5 cursor-pointer" onclick="removeCartItem()" title="Remove">✕</button>
          </div>
          <div class="text-[11px] text-[#C25B12] font-semibold mt-0.5 flex items-center gap-1.5">
            <span>✨</span>
            <span>${pricing.badge}</span>
          </div>
          <div class="text-[11px] text-[#736A61] mt-0.5">
            Verrina Skin Care 30ml Original Elixir
          </div>
        </div>
      </div>

      <div class="flex items-center justify-between pt-2 border-t border-[#E8DDD2]/80">
        <!-- Quantity Selector (+ / -) -->
        <div class="flex items-center border border-[#E8DDD2] rounded-lg bg-white px-2.5 py-1 text-xs shadow-2xs">
          <button onclick="changeCartBottleQty(-1)" class="px-2 text-gray-500 hover:text-black font-bold text-sm cursor-pointer" title="Kam karein">−</button>
          <span class="px-2 font-bold text-[#16120E]">${state.cartBottleCount} ${state.cartBottleCount === 1 ? 'Bottle' : (state.cartBottleCount >= 3 ? 'Bottles (4th Free)' : 'Bottles')}</span>
          <button onclick="changeCartBottleQty(1)" class="px-2 text-gray-500 hover:text-black font-bold text-sm cursor-pointer" title="Barhayein">+</button>
        </div>

        <!-- Price -->
        <div class="text-right">
          <div class="text-sm font-bold text-[#16120E]">${formatPKR(pricing.pricePKR)}</div>
          <div class="text-[10px] ${pricing.isFreeShipping ? 'text-green-700 font-semibold' : 'text-[#736A61]'}">
            ${pricing.isFreeShipping ? 'FREE TCS Express Delivery' : '+ Rs. 200 TCS Delivery'}
          </div>
        </div>
      </div>
    </div>
  `;

  container.innerHTML = html;

  const grandTotal = pricing.pricePKR + pricing.shippingPKR;
  if (subtotalEl) subtotalEl.textContent = formatPKR(grandTotal);

  if (pricing.isFreeShipping) {
    if (freeShipText) freeShipText.innerHTML = '🎉 Mubarak! Aap ne 2+ bottles par <strong>FREE TCS Delivery</strong> unlock kar li!';
    if (freeShipBar) freeShipBar.style.width = '100%';
  } else {
    if (freeShipText) freeShipText.innerHTML = '1 bottle mazeed add karein aur payein <strong>FREE TCS Delivery</strong>!';
    if (freeShipBar) freeShipBar.style.width = '50%';
  }
}

window.removeCartItem = function() {
  state.cartBottleCount = 0;
  renderCart();
};

window.changeCartBottleQty = function(delta) {
  state.cartBottleCount = Math.max(1, Math.min(4, state.cartBottleCount + delta));
  renderCart();
};

/* ==========================================================================
   7.5. Announcement Bar Rotator (Smooth 1-Line Transition)
   ========================================================================== */
function initAnnouncementRotator() {
  const slides = document.querySelectorAll('.announcement-slide');
  if (slides.length <= 1) return;
  let currentIdx = 0;
  setInterval(() => {
    slides[currentIdx].classList.remove('active');
    currentIdx = (currentIdx + 1) % slides.length;
    slides[currentIdx].classList.add('active');
  }, 3500);
}

/* ==========================================================================
   7.6. Mobile Hamburger Navigation Menu Drawer
   ========================================================================== */
function initMobileMenu() {
  const menuBtn = document.getElementById('mobile-menu-btn');
  const overlay = document.getElementById('mobile-nav-overlay');
  const closeBtn = document.getElementById('close-mobile-nav');

  if (!menuBtn || !overlay) return;

  function openMenu() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  menuBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closeMenu();
    }
  });

  const actionLinks = overlay.querySelectorAll('.mobile-nav-link, button');
  actionLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });
}

/* ==========================================================================
   8. Before & After Slider
   ========================================================================== */
function initBeforeAfterSlider() {
  const container = document.getElementById('ba-slider');
  const afterWrap = document.getElementById('ba-after-wrap');
  const handle = document.getElementById('ba-slider-handle');

  if (!container || !afterWrap || !handle) return;

  function syncAfterWidth() {
    const afterImg = afterWrap.querySelector('img');
    if (afterImg) {
      afterImg.style.width = `${container.clientWidth}px`;
      afterImg.style.height = `${container.clientHeight}px`;
    }
  }

  syncAfterWidth();
  window.addEventListener('resize', syncAfterWidth);

  let isDragging = false;

  function setSliderPos(x) {
    const rect = container.getBoundingClientRect();
    let pos = ((x - rect.left) / rect.width) * 100;
    pos = Math.max(0, Math.min(100, pos));
    afterWrap.style.width = `${pos}%`;
    handle.style.left = `${pos}%`;
  }

  container.addEventListener('mousedown', (e) => {
    isDragging = true;
    setSliderPos(e.clientX);
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    setSliderPos(e.clientX);
  });

  window.addEventListener('mouseup', () => { isDragging = false; });

  container.addEventListener('touchstart', (e) => {
    isDragging = true;
    setSliderPos(e.touches[0].clientX);
  }, { passive: true });

  window.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    setSliderPos(e.touches[0].clientX);
  }, { passive: true });

  window.addEventListener('touchend', () => { isDragging = false; });
}

/* ==========================================================================
   9. Accordion FAQs
   ========================================================================== */
function initFAQAccordion() {
  document.querySelectorAll('.faq-row').forEach(row => {
    const trigger = row.querySelector('.faq-trigger');
    if (trigger) {
      trigger.addEventListener('click', () => {
        const isOpen = row.classList.contains('active');
        document.querySelectorAll('.faq-row').forEach(r => r.classList.remove('active'));
        if (!isOpen) row.classList.add('active');
      });
    }
  });
}

/* ==========================================================================
   10. Sticky Quick Order Bar
   ========================================================================== */
function initStickyBar() {
  const bar = document.getElementById('sticky-quick-bar');
  const hero = document.getElementById('hero-section');

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (hero && bar) {
          const bottom = hero.getBoundingClientRect().bottom;
          if (bottom < 0) {
            bar.classList.add('visible');
          } else {
            bar.classList.remove('visible');
          }
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Handle click on all sticky pills (desktop + mobile)
  document.querySelectorAll('.sticky-pill-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const bId = btn.getAttribute('data-bundle-id');
      selectBundle(bId);
    });
  });
}

function updateStickyBar() {
  const bId = state.selectedBundle.id;
  const shipping = state.selectedBundle.isFreeShipping ? 0 : 200;
  const grandTotal = state.selectedBundle.pricePKR + shipping;

  // Sync active class on all pills
  document.querySelectorAll('.sticky-pill-btn').forEach(btn => {
    if (btn.getAttribute('data-bundle-id') === bId) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  const mobileBtnPrice = document.getElementById('mobile-sticky-btn-price');
  if (mobileBtnPrice) {
    mobileBtnPrice.textContent = `${formatPKR(grandTotal)} COD`;
  }
}

/* ==========================================================================
   11. Social Proof Notifications
   ========================================================================== */
function initSocialProof() {
  const toast = document.getElementById('social-toast');
  const nameEl = document.getElementById('toast-name');
  const locEl = document.getElementById('toast-location');
  const itemEl = document.getElementById('toast-item');

  if (!toast) return;

  const orders = [
    { name: 'Ayesha K.', location: 'DHA, Lahore', item: '2x Duo Radiance Protocol' },
    { name: 'Zahra M.', location: 'Clifton, Karachi', item: '2x Duo Radiance Protocol' },
    { name: 'Fatima S.', location: 'Sector F-8, Islamabad', item: '3x Glass Skin Vault' },
    { name: 'Maham B.', location: 'Gulberg, Lahore', item: '2x Duo Radiance Protocol' },
    { name: 'Khadija R.', location: 'Cantt, Rawalpindi', item: '1x Individual Bottle' }
  ];

  let i = 0;
  function showNext() {
    const o = orders[i % orders.length];
    i++;
    if (nameEl) nameEl.textContent = o.name;
    if (locEl) locEl.textContent = o.location;
    if (itemEl) itemEl.textContent = o.item;

    toast.classList.add('visible');
    setTimeout(() => toast.classList.remove('visible'), 4000);
  }

  setTimeout(() => {
    showNext();
    setInterval(showNext, 18000);
  }, 3500);
}

/* ==========================================================================
   12. Floating WhatsApp Support Button
   ========================================================================== */
function initWhatsAppFloating() {
  const links = document.querySelectorAll('.whatsapp-link-trigger');
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const calc = getCheckoutCalculation();
      const msg = encodeURIComponent(
        `Hi Verrina Skin Care! I would like to place an order for:\n\n` +
        `• Package: ${calc.title}\n` +
        `• Total Amount: ${formatPKR(calc.total)}\n` +
        `• Shipping: ${calc.isFreeShipping ? 'FREE TCS Express Delivery' : 'Rs. 200 Delivery'}\n` +
        `• Payment: Cash on Delivery (ya Advance EasyPaisa Rs. 100 OFF)\n\n` +
        `Please confirm my shipment.`
      );
      window.open(`https://wa.me/923170619644?text=${msg}`, '_blank');
    });
  });
}

/* ==========================================================================
   13. TikTok Video Reviews Modal
   ========================================================================== */
function initTikTokModal() {
  const modal = document.getElementById('tiktok-modal');
  const closeBtn = document.getElementById('close-tiktok-modal');
  if (!modal) return;

  window.openTikTokVideoModal = function(id, url) {
    const link = document.getElementById('tiktok-modal-link');
    if (link && url) link.href = url;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
}

/* ==========================================================================
   14. Master Modal Controller & Global Keyboard Dismissal
   ========================================================================== */
function closeAllModals() {
  closeCartDrawer();
  const modalIds = ['oneclick-modal', 'track-modal', 'about-modal', 'tiktok-modal', 'mobile-nav-overlay'];
  modalIds.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('open');
  });
  document.body.style.overflow = '';
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' || e.key === 'Esc') {
    closeAllModals();
  }
});
